import axios from "../../utils/axios";

export const getVideo = async (id) => {
    const response = await axios.get(`/videos/${id}`);
    return response.data;
};

export const putLikesApi = async ({ id, likes }) => {
    const response = await axios.patch(`/videos/${id}`, {
        likes: likes,
    });
    return response.data;
};

export const putUnLikesApi = async ({ id, unlikes }) => {
    const response = await axios.patch(`/videos/${id}`, {
        unlikes: unlikes,
    });
    return response.data;
};
